import { fetchBoardForEditor, resetEditor, selectActiveBoard, selectActiveTemplate, selectError, selectIsLoaded, selectIsLoading } from 'modules/manager/store';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export interface UseLoadBoardResult {
  templateId: number | null;
  boardId: number | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  activeTemplate: ReturnType<typeof selectActiveTemplate>;
  activeBoard: ReturnType<typeof selectActiveBoard>;
}

export function useLoadBoard(): UseLoadBoardResult {
  const dispatch = useAppDispatch();
  const { templateId: templateIdParam, boardId: boardIdParam } = useParams<{ templateId: string; boardId: string }>();

  const templateId = parseId(templateIdParam);
  const boardId = parseId(boardIdParam);

  const isLoading = useAppSelector(selectIsLoading);
  const isLoaded = useAppSelector(selectIsLoaded);
  const error = useAppSelector(selectError);
  const activeTemplate = useAppSelector(selectActiveTemplate);
  const activeBoard = useAppSelector(selectActiveBoard);

  useEffect(() => {
    if (templateId === null || boardId === null) return;
    dispatch(fetchBoardForEditor({ templateId, boardId }));
  }, [dispatch, templateId, boardId]);

  useEffect(() => {
    return () => {
      dispatch(resetEditor());
    };
  }, [dispatch]);

  return { templateId, boardId, isLoading, isLoaded, error, activeTemplate, activeBoard };
}

function parseId(raw: string | undefined): number | null {
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}
